<template>
  <div>
    <div :style="{ height: docHeight }"
         class="loginImageBG">
      <img src="../assets/images/yq.png"
           class="imgbg"
           mode='aspectFit' />
      <div class="recommend-text">
        <span>推荐人:{{parentAgengName}}</span>
        <span style="margin-left:25px">推荐号码:{{parentMobileTm}}</span>
      </div>
      <div class="content">
        <img src="../assets/images/smallIco.png"
             class="smallIco"
             mode='aspectFit' />
        <van-form @submit="onSubmit">
          <van-field v-model="agtMobile"
                     name="手机号码"
                     label="手机号码"
                     type="number"
                     clearable
                     maxlength="11"
                     placeholder="请输入手机号码"
                     :rules="[{ required: true, message: '请输入手机号码' }]" />
          <van-field v-model="checkCode"
                     center
                     clearable
                     label="验证码"
                     name="验证码"
                     type="number"
                     maxlength="6"
                     placeholder="请输入短信验证码"
                     :rules="[{ required: true, message: '请输入验证码' }]">
            <template #button>
              <van-button size="small"
                          type="info"
                          @click="checkNoClick"
                          native-type="button">{{yzmText}}</van-button>
            </template>
          </van-field>
          <van-field v-model="password"
                     type="password"
                     name="密码"
                     label="密码"
                     placeholder="请输入密码"
                     :rules="[
        { validator: (val) => {
              return  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z0-9]{6,20}$/.test(val)
         },
         message: '请输入6～20位大小写字母+数字的组合密码'
         }
         ]" />
          <van-field v-model="password2"
                     type="password"
                     name="确认密码"
                     label="确认密码"
                     placeholder="请再次输入密码"
                     :rules="[{ required: true, validator:validator2,message: '确认密码与密码不一致' }]" />
          <van-field v-model="agentName"
                     name="服务商名称"
                     label="服务商名称"
                     clearable
                     placeholder="请输入服务商名称"
                     :rules="[{ required: true, message: '请输入服务商名称' }]" />
          <van-checkbox v-model="checked"
                        shape="square"
                        checked-color="#FFCE05"
                        style="margin-left:20px;margin-top:15px"
                        icon-size="16px">我已阅读并同意<span class="link-text"
                  @click="goUserDeal()">《用户协议》</span></van-checkbox>
          <div style="margin: 16px;">
            <van-button round
                        block
                        color="linear-gradient(to right, #FFCE05, #FBC002)"
                        native-type="submit"
                        class="button-text">立即注册</van-button>
          </div>
          <div style="text-align: center;padding-bottom:20px">
            已有账号？<span class="link-text"
                  @click="goApp()">下载APP</span>
          </div>
        </van-form>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'vant'
import { paramsToSring, md5crypt } from '@/assets/js/AES'
import { ref } from 'vue'
// var i = 0

export default {
  data () {
    return {
      parentAgentId: sessionStorage.getItem('parentAgentId'),
      parentAgengName: sessionStorage.getItem('parentAgengName'),
      parentMobile: sessionStorage.getItem('parentMobile'),
      agtMobile: '',
      checkCode: '',
      password: '',
      password2: '',
      agentName: '',
      second: 60, // 验证码倒计时
      yzmText: '获取',
      checkNoIsActive: false,
      checked: false,
      docHeight: '',
      parentMobileTm: ''
    }
  },
  created () {
    // 判断浏览器
    // if (/MicroMessenger/.test(window.navigator.userAgent)) {
    //   this.client = 'WX'
    //   this.wxOrAli = true
    // } else if (/AlipayClient/.test(window.navigator.userAgent)) {
    //   this.client = 'ALI'
    //   this.wxOrAli = true
    // } else {
    //   this.client = 'UNIONCODE'
    //   this.wxOrAli = false
    //   console.log('this.client', this.client)
    // }
    // // 判断是否https
    // var ishttps = document.location.protocol === 'https:'
    // if (ishttps) {
    //   this.isHttps = true
    // } else {
    //   this.isHttps = false
    // }
  },
  mounted () {
    this.parentMobileTm = this.parentMobile ? `${this.parentMobile.substr(0, 3)}***${this.parentMobile.substr(7)}` : ''
    // this.getPosInfoByTmsNo()
    this.$nextTick(() => {
      let docHeight = document.documentElement.clientHeight
      console.log('可视区域高度', docHeight)
      this.docHeight = docHeight + 'px'
      // 获取屏幕高度，为元素添加高度
      // 不使用 100vh 的原因：安卓手机上，键盘抬起会算作屏幕元素，100vh会发生变化，键盘收起时，100vh会比初始值小
    })
  },
  watch: {

  },
  // components: {},
  methods: {
    validator (val) {
      if (val.length < 6 || val.length > 20) {
        return false
      }
    },
    validator2 (val) {
      if (val !== this.password) {
        return false
      }
    },
    checkNoClick: async function () {
      if (!this.agtMobile) {
        Toast(`请先输入手机号码`)
        return
      }
      console.log('checkNoIsActive', this.checkNoIsActive)
      if (this.checkNoIsActive === true) {
        return
      } else {
        this.checkNoIsActive = true
      }
      console.log('获取验证码')
      const params = {
        parentAgentId: this.parentAgentId,
        phone: this.agtMobile,
        smsBizType: 'AGENT_REGISTER'
      }
      try {
        this.getRequest('/api/cold-light-core/app/agent/sendCode', params).then(res => {
          if (res && res.data.code === 200) {
            Toast.success('发送成功')
            var interval = setInterval(() => {
              --this.second
              this.yzmText = this.second + '秒'
            }, 1000)
            setTimeout(() => {
              clearInterval(interval)
              this.checkNoIsActive = false
              this.second = 60
              this.yzmText = '获取'
            }, 60000)
          } else {
            this.checkNoIsActive = false
          }
        })
      } catch (error) {
        console.log('报错了')
        this.checkNoIsActive = false
      }
    },
    onSubmit (values) {
      console.log('submit', values)
      if (!this.checked) {
        Toast(`请勾选同意协议`)
        return
      }
      const params = {
        clientId: 'agentapp',
        checkCode: this.checkCode,
        agtMobile: this.agtMobile,
        userPassword: md5crypt(this.password),
        agentName: this.agentName,
        parentAgentId: this.parentAgentId,
        parentAgengName: this.parentAgengName,
        parentMobile: this.parentMobile
      }
      this.jsonPostRequest('/api/cold-light-core/app/agent/autoReg', params).then(res => {
        if (res && res.data.code === 200) {
          Toast.success('注册成功')
        } else {
          Toast(res.data.msg)
        }
      })
    },
    goUserDeal () {
      this.$router.push({
        path: '/userDeal'
      })
    },
    goApp () {
      this.$router.push({
        path: '/appDownload'
        // query: { merchantId: '123', sn: '321' }
      })
    }
  }
}
</script>
<style scoped>
.loginImageBG {
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  background-image: url("../assets/images/bg.png");
  background-size: 100% 100%;
  width: 100%;
  /* height: 100vh; */
  overflow: auto;
}
.imgbg {
  width: 304px;
  height: 64px;
  margin-top: 50px;
}
.recommend-text {
  font-size: 16px;
  color: #693106;
  margin-top: 15px;
}
.content {
  background-color: #ffffff;
  width: 340px;
  height: auto;
  margin-top: 110px;
  border-radius: 10px;
  /* padding-top: 20px; */
}
.smallIco {
  width: 137px;
  height: 33px;
  clear: both;
  display: block;
  margin: auto;
  margin-bottom: 5px;
}
.button-text span {
  color: #323233;
  font-weight: 500;
}
.link-text {
  color: #fbc82f;
}
</style>
<style>
.van-key--blue {
  background-color: #ff9500 !important;
}
.van-field--error .van-field__control,
.van-field--error .van-field__control::placeholder {
  color: #cccccc !important;
}
</style>
